import { render, staticRenderFns } from "./kegiatan.vue?vue&type=template&id=14abb808&"
import script from "./kegiatan.vue?vue&type=script&lang=js&"
export * from "./kegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions,QSelect,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions,QSelect})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
